module.exports = __webpack_public_path__ + "img/bas-comment.e52eb98e.jpg";